<template>
  <!-- 導下載視窗 -->
  <ui-modal
    ref="guideDownloadAppModal"
    content-class="guide-download-app-dialog"
    :forcing="true"
    :header-title="guideDownloadDialogOptions.title || ''"
    :hide-overlay="false"
    @close-icon-event="hideModal"
  >
    <v-sheet class="guide-download-app-container" min-height="142" max-height="60vh">
      <v-img class="funnow-logo-icon mb-5" src="@/assets/images/logo/dna-icon-appicon-40.svg?url" max-width="60" max-height="60" />

      <p class="mb-6">{{ guideDownloadDialogOptions.context || $t('grouping_content') }}</p>

      <div class="button-group">
        <v-btn class="large--btn" min-width="32" color="orange50" elevation="0" @click="guideDownloadApp">
          {{ $t('download_app_button') }}
        </v-btn>
      </div>
    </v-sheet>
  </ui-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import tools from '@/mixin/tools'

import UiModal from '@/components/dialog/ui-modal'

export default {
  name: 'GuideDownloadAppModal',
  components: {
    UiModal,
  },
  mixins: [tools],
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      guideDownloadAppDialog: 'dialog/guideDownloadAppDialog',
      guideDownloadDialogOptions: 'dialog/guideDownloadDialogOptions',
    }),
  },
  watch: {
    guideDownloadAppDialog(dialogState) {
      if (dialogState) {
        this.openGuideDownloadAppModal()
      }
    },
  },
  mounted() {},
  methods: {
    openGuideDownloadAppModal() {
      this.$refs.guideDownloadAppModal.showModal()
    },
    guideDownloadApp() {
      location.href = '/app'
    },
    showModal() {
      this.$refs.guideDownloadAppModal.showModal()
    },
    hideModal() {
      this.$store.dispatch('dialog/setGuideDownloadAppDialog', { state: false, title: '' })
      this.$refs.guideDownloadAppModal.hideModal()
    },
  },
}
</script>

<style scoped lang="scss">
.guide-download-app-container {
  padding: 12px 24px 24px;
  overflow-y: auto;

  .funnow-logo-icon {
    margin: auto;
  }

  .button-group {
    display: flex;
    justify-content: flex-end;

    button {
      flex: 1;
    }
  }
}
</style>
